import React, { useEffect, useState } from "react";
import ReportHeader from "../../components/Report/ReportHeader";
import ReportTable from "../../components/Report/ReportTable";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { getFormattedReportData } from "../../helper";
import { fetchReportMerchants } from "../../services/merchantService";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";

const LIMIT = 10;

const Report = () => {
  let navigate = useNavigate();
  const [responseData, setResponseData] = useState<any>([]);
  const [totalReports, setTotalReports] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  const [isTableLoading, setTableLoading] = useState(false);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const fetchMerchantsList = async (
    activePage: number,
    limitCount: number,
    queryString: string
  ) => {
    setTableLoading(true);
    try {
      const response = await fetchReportMerchants(
        activePage,
        limitCount,
        queryString
      );
      setTableLoading(false);
      let formattedMerchantListData = getFormattedReportData(
        response.data.data
      );
      setResponseData(formattedMerchantListData);
      setTotalReports(response.data.count);
    } catch (error: any) {
      setTableLoading(false);
      if (navigator.onLine) {
        setIsError(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  const handleRowClick = (item: any) => {
    navigate(`/admin/report/${item.merchant_id}`);
  };

  const handleMerchantSearch = (value: string) => {
    setSearchQuery(value);
    setCurrentPage(1);
    fetchMerchantsList(1, LIMIT, value);
  };

  useEffect(() => {
    fetchMerchantsList(currentPage, LIMIT, searchQuery);
  }, [currentPage, searchQuery]);

  return (
    <ReportPageContainer>
      <ReportHeader
        handleSearch={handleMerchantSearch}
        searchQuery={searchQuery}
      />
      <ReportTable
        onRowClick={handleRowClick}
        data={responseData}
        totalData={totalReports}
        isTableDataLoading={isTableLoading}
        currentPage={currentPage}
        rowsPerPage={LIMIT}
        onPageChange={handlePageChange}
      />
      {isError && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsError}
          onSubmit={() => setIsError(false)}
        />
      )}
    </ReportPageContainer>
  );
};

export default Report;

const ReportPageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
